import React from 'react';
const QuizContext = React.createContext<{
    pet: 'dog' | 'cat' | null;
    setPetBranch: (pet: 'dog' | 'cat' | null) => void;
}>({
    pet: null,
    setPetBranch: () => { },
});
export default QuizContext;
